import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const AddNote = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M14,2 L20,8 L20,20 C20,21.1 19.1,22 18,22 L18,22 L5.99,22 C4.89,22 4,21.1 4,20 L4,20 L4.01,4 C4.01,2.9 4.9,2 6,2 L6,2 L14,2 Z M13,11 L11,11 L11,14 L8,14 L8,16 L11,16 L11,19 L13,19 L13,16 L16,16 L16,14 L13,14 L13,11 Z M13,3.5 L13,9 L18.5,9 L13,3.5 Z" })));
};
export default AddNote;
